 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({}[chunkId]||chunkId) + "." + {"chunk-01f1139b":"8e07e194","chunk-0434f1c9":"1d68e37b","chunk-05c81fd8":"f7a3098d","chunk-069d623c":"3771543a","chunk-096dd9be":"2ec8a76d","chunk-09b4743c":"f925920e","chunk-1061bfb8":"7c935fa1","chunk-11b839fe":"1ae9a358","chunk-09a66686":"3a04b053","chunk-b1357e9a":"e35c5c31","chunk-1b533927":"728672ef","chunk-154addf6":"1ff3199e","chunk-16a29b0a":"e3a63c99","chunk-16eb22bf":"09e74fb7","chunk-18e7d5b7":"81899b47","chunk-1cae3b30":"c4b3a59e","chunk-236ffd79":"47ca9837","chunk-25f5b051":"b1ac56a0","chunk-277b4af5":"20c73bef","chunk-2d0e140f":"8d7805c7","chunk-48c2a991":"e4361159","chunk-5be958ca":"714db765","chunk-5019a474":"ca3f7f74","chunk-f74b134e":"17d28172","chunk-66aa5048":"d417cd26","chunk-7cbf777f":"7466ea67","chunk-b591cdb4":"96aec4d7","chunk-640ed9f1":"c11adf69","chunk-87007078":"1c3d6398","chunk-cec3eb6a":"21806242","chunk-2d6669d0":"c41b362e","chunk-33b2e1d2":"dd943588","chunk-3b7e5cce":"b3f54497","chunk-8bf86320":"a3f0105e","chunk-d784b046":"553ea98c","chunk-4bcc3044":"34db19cf","chunk-4da3382c":"45731339","chunk-51787f6e":"cdcecaa8","chunk-5463c3e6":"a0b4f4b2","chunk-59ca4dd0":"edb9e024","chunk-61a06981":"a7b674fe","chunk-622e6f9e":"c219735e","chunk-665adbe0":"905c535e","chunk-0cc39272":"bebb6a64","chunk-67e577a2":"9fcbcbcf","chunk-699f73f1":"de27712a","chunk-729123ba":"e169abe6","chunk-731434c0":"5808359f","chunk-75635252":"195fd752","chunk-7adaedc0":"a4b758bb","chunk-7d0c0895":"88748ac2","chunk-14688fe5":"8f095b51","chunk-2838dd31":"7a3f6289","chunk-3bc29563":"a495775f","chunk-7ff892ba":"10cb7d6d","chunk-99061cbe":"7835afd6","chunk-9937e93e":"83925338","chunk-cbf17334":"5d2c8228","chunk-365af53e":"81b6ad65","chunk-c182a89a":"991e9e30","chunk-d0bda3a6":"9ec813d9","chunk-d83e01e6":"282250e5","chunk-d9558900":"81c9c193","chunk-dc3943a8":"e824876f","chunk-e66bcf9a":"de73658a","chunk-e9309a3c":"6b47d7ab","chunk-f7023d12":"a157b513","chunk-f817072e":"88486b8c","chunk-f98dad5a":"9918ceb1"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"chunk-01f1139b":1,"chunk-0434f1c9":1,"chunk-05c81fd8":1,"chunk-069d623c":1,"chunk-096dd9be":1,"chunk-09b4743c":1,"chunk-11b839fe":1,"chunk-09a66686":1,"chunk-b1357e9a":1,"chunk-1b533927":1,"chunk-154addf6":1,"chunk-16a29b0a":1,"chunk-16eb22bf":1,"chunk-18e7d5b7":1,"chunk-1cae3b30":1,"chunk-236ffd79":1,"chunk-25f5b051":1,"chunk-277b4af5":1,"chunk-48c2a991":1,"chunk-5be958ca":1,"chunk-5019a474":1,"chunk-f74b134e":1,"chunk-7cbf777f":1,"chunk-b591cdb4":1,"chunk-640ed9f1":1,"chunk-87007078":1,"chunk-cec3eb6a":1,"chunk-2d6669d0":1,"chunk-33b2e1d2":1,"chunk-3b7e5cce":1,"chunk-8bf86320":1,"chunk-d784b046":1,"chunk-4bcc3044":1,"chunk-4da3382c":1,"chunk-51787f6e":1,"chunk-5463c3e6":1,"chunk-59ca4dd0":1,"chunk-61a06981":1,"chunk-622e6f9e":1,"chunk-665adbe0":1,"chunk-0cc39272":1,"chunk-67e577a2":1,"chunk-699f73f1":1,"chunk-729123ba":1,"chunk-731434c0":1,"chunk-75635252":1,"chunk-7adaedc0":1,"chunk-7d0c0895":1,"chunk-14688fe5":1,"chunk-2838dd31":1,"chunk-3bc29563":1,"chunk-7ff892ba":1,"chunk-99061cbe":1,"chunk-9937e93e":1,"chunk-cbf17334":1,"chunk-365af53e":1,"chunk-c182a89a":1,"chunk-d0bda3a6":1,"chunk-d83e01e6":1,"chunk-e66bcf9a":1,"chunk-e9309a3c":1,"chunk-f7023d12":1,"chunk-f817072e":1,"chunk-f98dad5a":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({}[chunkId]||chunkId) + "." + {"chunk-01f1139b":"84add2ed","chunk-0434f1c9":"1afb1ad7","chunk-05c81fd8":"ffd7e113","chunk-069d623c":"edc3ee61","chunk-096dd9be":"fe9dbde3","chunk-09b4743c":"4e1d42eb","chunk-1061bfb8":"31d6cfe0","chunk-11b839fe":"b868c9af","chunk-09a66686":"67ad097f","chunk-b1357e9a":"3e96a622","chunk-1b533927":"8ae981e5","chunk-154addf6":"135c0e43","chunk-16a29b0a":"83726a48","chunk-16eb22bf":"63d7e759","chunk-18e7d5b7":"728e8c6e","chunk-1cae3b30":"c320a803","chunk-236ffd79":"3d706c24","chunk-25f5b051":"971ec0de","chunk-277b4af5":"e0c56e64","chunk-2d0e140f":"31d6cfe0","chunk-48c2a991":"e5ef9801","chunk-5be958ca":"49050fec","chunk-5019a474":"72827ca4","chunk-f74b134e":"de0ca6ff","chunk-66aa5048":"31d6cfe0","chunk-7cbf777f":"7b4b790d","chunk-b591cdb4":"ebbbcf1e","chunk-640ed9f1":"7cf35ec8","chunk-87007078":"50c688fe","chunk-cec3eb6a":"448a6c63","chunk-2d6669d0":"7c46e050","chunk-33b2e1d2":"e9abaafe","chunk-3b7e5cce":"0fc907ca","chunk-8bf86320":"aafecad4","chunk-d784b046":"c6623c0e","chunk-4bcc3044":"42d8a153","chunk-4da3382c":"e95fe0fb","chunk-51787f6e":"d00d2fc4","chunk-5463c3e6":"8ba87b8e","chunk-59ca4dd0":"bc507d23","chunk-61a06981":"0e56baee","chunk-622e6f9e":"05c5110b","chunk-665adbe0":"4f10da16","chunk-0cc39272":"01f45edd","chunk-67e577a2":"b0a269f5","chunk-699f73f1":"b86c5c6c","chunk-729123ba":"33477ecc","chunk-731434c0":"af92a3a9","chunk-75635252":"ca4e612f","chunk-7adaedc0":"41e5ddb6","chunk-7d0c0895":"e35716cb","chunk-14688fe5":"866158ae","chunk-2838dd31":"94e0bb3b","chunk-3bc29563":"c3c67120","chunk-7ff892ba":"0fc89efb","chunk-99061cbe":"c6dc0af9","chunk-9937e93e":"468a2f0e","chunk-cbf17334":"5dfbdc89","chunk-365af53e":"f8af52ed","chunk-c182a89a":"f6309a89","chunk-d0bda3a6":"fe339d7c","chunk-d83e01e6":"b77125ac","chunk-d9558900":"31d6cfe0","chunk-dc3943a8":"31d6cfe0","chunk-e66bcf9a":"73c2a915","chunk-e9309a3c":"2c98444b","chunk-f7023d12":"05f544b8","chunk-f817072e":"b16beb5d","chunk-f98dad5a":"55f78d00"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://yijin-cdn.yjhlnews.cn/100003/ucenter/platform/static/dist/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp_ucp-cli3"] = window["webpackJsonp_ucp-cli3"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
